import React from "react";
import { LegalPage } from "../components/LegalPage";
import { impressum } from "../data/legal";
export function Impressum() {
  return <LegalPage title="Impressum" sections={impressum} data-id="element-343" data-mp="ur8ki66voffg" />;
}